import { BlogTableOfContent } from '@doltech/ui/lib/figma/Blog/BlogTableOfContent';
import { deviceBreakpoints } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import * as React from 'react';
import styled from 'styled-components';
import { useAppScrollRef } from '@doltech/core/lib/appScroll/withAppScroll';

const Main = styled.div`
  .blog-sticky {
    width: 214px;
    min-width: 214px;
    max-width: 214px;
  }
  .blog-table-of-content {
    margin-top: 0;
  }

  @media ${deviceBreakpoints.fromDesktop} {
    position: absolute;
  }
`;

export const LeftSidebarPreviewSample = ({
  tocTitle,
  items,
  stickyId = 'sample-table-of-content',
}) => {
  const { appScrollRef } = useAppScrollRef();
  return (
    <Main className="right-sidebar-preview">
      <BlogTableOfContent
        stickyMode="ALWAYS_SHOW"
        items={items}
        editorItems={null}
        tocTitle={tocTitle}
        stickyId={stickyId}
        scrollContainerElm={appScrollRef.current}
        stickOnElm=".right-sidebar-stick"
        hideWhenIntersectWithElms={[
          '#feedback',
          '#footer-author',
          '#content-footer',
          '#compact-footer',
          '#shared-footer',
          '.footer-with-register',
          '.common-footer',
        ]}
        stickOnElmPosition={{
          align: 'left',
          gapInPx: 32,
        }}
      />
    </Main>
  );
};
